import SpeechBox from 'components/SpeechBox';
import styled, { keyframes } from 'styled-components';
import tw from 'twin.macro';

const scale = keyframes`
  0% { scale: 0; }
  100% { scale: 1; }
`;

const fade = keyframes`
   0% {  opacity: 0;}
  100% {  opacity: 1; }
`;
export const Wrapper = styled.div`
  ${tw`w-full max-w-[350px] sm:max-w-sm origin-bottom-left
  flex justify-center items-center gap-6 `}
  animation: ${fade} 0.2s ease-out 0.6s backwards;
`;

export const Content = tw.div`
w-full h-full max-h-[14rem]
 flex flex-col justify-center items-center gap-4 py-5 px-3  
`;

export const TitleBox = tw.div`
w-full max-h-[14rem] overflow-auto
`;

export const AnimetedSpeechBox = styled(SpeechBox)`
  ${tw`origin-bottom-left `}
  animation: ${scale} 0.2s ease-out 0.6s backwards;
`;
